import React, { useState } from 'react';
import './Settings.scss';
import { OUR_SERVICE_CARD_ONE, OUR_SERVICE_CARD_THREE, OUR_SERVICE_CARD_TWO } from '../../services/ImageService';

type Template = {
  id: number;
  title: string;
  category: string;
  image: string;
};



const TemplateGallery: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<'predefined' | 'saved'>('predefined');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchText, setSearchText] = useState('');

  const templates: Template[] = [
    { id: 1, title: 'Tempalte-1', category: 'general', image: OUR_SERVICE_CARD_ONE },
    { id: 2, title: 'Word Document', category: 'hr', image: OUR_SERVICE_CARD_TWO },
    { id: 3, title: 'Agrement-1', category: 'agreements', image: OUR_SERVICE_CARD_THREE },
  ];
  
  const categories = [
    { value: 'all', label: 'All' },
    { value: 'general', label: 'General' },
    { value: 'hr', label: 'HR' },
    { value: 'personal', label: 'Personal' },
    { value: 'accounts', label: 'Accounts' },
    { value: 'agreements', label: 'Agreements' },
  ];

  const filteredTemplates = templates.filter(t =>
    (selectedCategory === 'all' || t.category.toLowerCase() === selectedCategory) &&
    t.title.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="template-gallery container">
    

      <div className="columns is-vcentered is-mobile mb-4">
        <div className='column is-6'>
        <div className="tabs is-toggle is-marginless custom-tabs">
        <ul>
          <li className={selectedTab === 'predefined' ? 'is-active' : ''}>
            <a onClick={() => setSelectedTab('predefined')}>
              <strong>Pre-Defined</strong>
            </a>
          </li>
          <li className={selectedTab === 'saved' ? 'is-active' : ''}>
            <a onClick={() => setSelectedTab('saved')}>
              <strong className="has-text-danger">Saved Templates</strong>
            </a>
          </li>
        </ul>
      </div>
        </div>
        <div className="column is-3">
          <input
            type="text"
            className="input"
            placeholder="Search templates..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div className="column is-3 has-text-right">
          <div className="select">
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              {categories.map(cat => (
                <option key={cat.value} value={cat.value}>{cat.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {selectedTab === 'predefined' && (
        <div className="columns is-multiline">
          {filteredTemplates.map(template => (
            <div key={template.id} className="column is-one-quarter">
              <div className="card template-card">
                <div className="card-content">
                  <p className="title is-6 has-text-centered">{template.title}</p>
                  <figure className="image is-4by3 mb-3">
                    <img src={template.image} alt={template.title} />
                  </figure>
                  <div className="buttons is-centered">
                    <button className="button is-text has-text-danger">Preview</button>
                    <button className="button is-text has-text-danger">Use</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {filteredTemplates.length === 0 && (
            <p className="has-text-grey has-text-centered is-fullwidth mt-5">
              No templates found.
            </p>
          )}
        </div>
      )}

      {selectedTab === 'saved' && (
        <div className="notification is-light is-info has-text-centered">
          You don't have any saved templates yet.
        </div>
      )}
    </div>
  );
};

export default TemplateGallery;
